import { render } from "./ManageBank.vue?vue&type=template&id=630c0c8e&scoped=true"
import script from "./ManageBank.vue?vue&type=script&lang=js"
export * from "./ManageBank.vue?vue&type=script&lang=js"

import "./ManageBank.vue?vue&type=style&index=0&id=630c0c8e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630c0c8e"]])

export default __exports__